import { Trans } from '@lingui/react/macro';
import { Button, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDownloadCSV } from './useDownloadCSV';
export function CSVDownload() {
    const { download, loading } = useDownloadCSV();
    return (<Button type="button" size="xs" onClick={download} disabled={loading} appearance="secondary">
      {loading ? <Loader /> : <Falcon icon="download"/>}
      <Trans comment="CSV download button: Label">Download</Trans>
    </Button>);
}
